import React from 'react';

import { messages } from '../messages';
import { RateShopperColumn } from './component';
import { SERVICE_COLLECTION } from '../../../../filters/constants';

export const RateShopper = {
  getMessageDescriptor: () => messages.rateShopper,
  id: SERVICE_COLLECTION,

  render: (data, { isExpanded = false, isFirstRow = true } = {}) => {
    if (!data || (isExpanded && !isFirstRow)) {
      return '';
    }
    return <RateShopperColumn fulfillmentPlanId={data.id} />;
  },
};
